<template>
  <!--
    The "this is an add-on, a request does not turn it on" message that sits right under every
    FeatureRequestButton. Wording lives in src/utils/featureRequestCopy.js. The repo guardrail
    cypress/node-tests/feature-request-note-guardrail.test.js fails if a button has no note.
  -->
  <div class="frn" :class="{ 'frn--compact': compact }" data-test="feature-request-note">
    <span class="frn__tag">{{ tag }}</span>
    <span class="frn__text">{{ text }}</span>
  </div>
</template>

<script>
import { featureRequestNote, featureRequestNoteShort, FEATURE_REQUEST_TAG } from '@/utils/featureRequestCopy.js';

export default {
  name: 'FeatureRequestNote',

  props: {
    // The same key the button beside it sends. Deliberately NOT named feature-key: that attribute is
    // what feature-request-paid-only-guardrail counts as a request surface.
    feature: { type: String, required: true },
    // One short sentence and tighter type, for a card with a fixed height (the dashboard's widgets).
    compact: { type: Boolean, default: false },
  },

  computed: {
    tag() {
      return FEATURE_REQUEST_TAG;
    },
    text() {
      return this.compact ? featureRequestNoteShort(this.feature) : featureRequestNote(this.feature);
    },
  },
};
</script>

<style lang="scss" scoped>
.frn {
  box-sizing: border-box;
  width: 100%;
  max-width: 340px;
  margin: 10px 0 0;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #fde68a;
  background: #fffbeb;
  color: #78350f;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 400;
  text-align: left;
  white-space: normal;
}

.frn--compact {
  margin-top: 6px;
  padding: 5px 8px;
  font-size: 11px;
  line-height: 1.35;
}

.frn__tag {
  display: inline-block;
  margin-right: 6px;
  padding: 1px 8px;
  border-radius: 999px;
  background: #fde68a;
  color: #78350f;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
  vertical-align: 1px;
}

.frn--compact .frn__tag {
  padding: 0 6px;
  font-size: 10px;
}
</style>
